import React, { createContext, ReactNode, useState } from 'react'
import { DateRange } from '../AuditBot.hooks'

export type AuditRunContextType = {
  auditId?: string
  range?: DateRange
  setAuditId: React.Dispatch<React.SetStateAction<string | undefined>>
  setDateRange: React.Dispatch<React.SetStateAction<DateRange | undefined>>
}

export const AuditRunContext = createContext<AuditRunContextType>({
  auditId: undefined,
  range: undefined,
  setAuditId: () => null,
  setDateRange: () => null,
})

export const AuditRunProvider = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const [auditId, setAuditId] = useState<string>()
  const [range, setDateRange] = useState<DateRange>()

  return (
    <AuditRunContext.Provider
      value={{
        auditId,
        range,
        setAuditId,
        setDateRange,
      }}
    >
      {children}
    </AuditRunContext.Provider>
  )
}
